<ng-template #popupPayment>
    <div class="centered-content">
        <div class="popup-info-content">
            <div class="content">
                <h3 nxHeadline="subsection-large">{{ "popup.payment-method.text" | translate }}</h3>
                <a href="tel:{{'popup.payment-method.mobile'|translate}}"><cpc-button size="x-small" mode="tertiary">{{ "popup.payment-method.mobile" |
                    translate }}
                </cpc-button></a>
                <p [innerHTML]="'popup.payment-method.opening' | translate "></p>
                <cpc-illustration name="womanWithLaptopTalkingOnThePhone" width="256px">
                </cpc-illustration>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #popupVehicle>
    <div class="centered-content">
        <div class="popup-info-content">
            <div class="content">
                <h3 nxHeadline="subsection-large">{{ "popup.insured-vehicle.text" | translate }}</h3>
                <a href="tel:{{'popup.payment-method.mobile'|translate}}"><cpc-button size="x-small" mode="tertiary">{{ "popup.insured-vehicle.mobile" |
                    translate }}
                </cpc-button></a>
                <p [innerHTML]="'popup.insured-vehicle.opening' | translate"></p>
                <cpc-illustration name="womanWithLaptopTalkingOnThePhone" width="256px">
                </cpc-illustration>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #popupVehicle2>
  <div class="centered-content">
      <div class="popup-info-content">
          <div class="content">
              <h3 nxHeadline="subsection-large">{{ "popup.insured-vehicle.newtext" | translate }}</h3>
              <a href="tel:{{'popup.payment-method.mobile'|translate}}"><cpc-button size="x-small" mode="tertiary">{{ "popup.insured-vehicle.mobile" |
                  translate }}
              </cpc-button></a>
              <p [innerHTML]="'popup.insured-vehicle.opening' | translate"></p>
              <cpc-illustration name="womanWithLaptopTalkingOnThePhone" width="256px">
              </cpc-illustration>
          </div>
      </div>
  </div>
</ng-template>
